import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from '../../../../shared/services/base-web.service';

@Injectable()
export class FollowUpEmailService {
    constructor(
        private _baseWebService: BaseWebService
    ) { }

    getFollowupEmailTemplate(type: string, contactInfo: any) {
        const data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;

        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        let URL = '';
        switch (type) {
            case 'follow-up':
            case 'consultation_followup':
                URL = 'v1/followup_communications/';
                break;

            case 'vc-follow-up':
            case 'virtual_consultation_followup':
                URL = 'v1/va/vc_followup/';
                break;

            case 'referral':
            case 'patient_referral_followup':
                URL = 'v1/patient_referral/';
                break;

            case 'parent-follow-up':
            case 'parent_ortho_followup':
                URL = 'v1/parent_relapse_communications/';
                break;

            case 'patient-follow-up':
            case 'patient_ortho_followup':
                URL = 'v1/patient_relapse_communications/';
                break;

            case 'non-start-follow-up':
            case 'non_start_tracking_followup':
                URL = 'v1/non_start_followup_communications/';
                break;

            default:
                break;
        }

        const requestId = (contactInfo.fromSection === 'actionRequiredList') ? contactInfo.communication_id : contactInfo.id;

        return this._baseWebService.request(URL + requestId + '/contact/', 'get')
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
      * Function for handling service call errors
      * @param  {Response|any} error contains error data
      */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}